var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stats-widget',{attrs:{"title":_vm.$t('Interrupted'),"color":"error","icon":"mdi-progress-clock","stat":_vm.interruptedOrderCount}})
}
var staticRenderFns = []

export { render, staticRenderFns }